/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchProductsButtons from "./buttons.js";
import liveSearchProductsError from "./error.js";
import liveSearchProductsEvents from "./events.js";
import liveSearchProductsFilter from "./filter.js";
import liveSearchProductsLayout from "./layout.js";
import liveSearchProductsMapping from "./mapping.js";
import liveSearchProductsObserver from "./observer.js";
import liveSearchProductsPages from "./pages.js";
import liveSearchProductsRequest from "./request.js";

const liveSearchProducts = {
    products: [],
    productsInitialLoaded: false,
    productsLoading: true,
    ...liveSearchProductsButtons,
    ...liveSearchProductsError,
    ...liveSearchProductsEvents,
    ...liveSearchProductsFilter,
    ...liveSearchProductsLayout,
    ...liveSearchProductsMapping,
    ...liveSearchProductsObserver,
    ...liveSearchProductsPages,
    ...liveSearchProductsRequest
}

export default liveSearchProducts;
